import '.h{width:100%;}.ssr-plugin'
import '.ba{max-width:440px;}.ssr-plugin'
import '.k{margin:0 auto;}.ssr-plugin'
import '.bb{border:1px solid #262626;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.i{flex-direction:column;}.ssr-plugin'
import '.bc{align-items:start;}.ssr-plugin'
import '.bd{justify-content:flex-start;}.ssr-plugin'
import '.be{padding:32px;}.ssr-plugin'
import '.bf{margin-bottom:12px;}.ssr-plugin'
import '.bg{border-top:1px solid #262626;}.ssr-plugin'
import '.bh{position:fixed;}.ssr-plugin'
import '.bi{inset:0px;}.ssr-plugin'
import '.d{align-items:center;}.ssr-plugin'
import '.c{justify-content:center;}.ssr-plugin'
import '.b{height:100vh;}.ssr-plugin'
import '.bj{overflow:hidden;}.ssr-plugin'
import { styled } from 'inlines'
import { Button } from '../components/Button'
import { useEffect, useState } from 'react'
import { Spinner } from '../components/Spinner'
import { useTheme } from '../providers/useTheme'

const Loading = () => {
  const [isDown, setIsDown] = useState(false)
  const [isSlow, setIsSlow] = useState(false)
  const { colors } = useTheme()

  useEffect(() => {
    const timer1 = setTimeout(() => setIsDown(true), 15e3)
    const timer2 = setTimeout(() => setIsSlow(true), 3e3)
    return () => {
      clearTimeout(timer1)
      clearTimeout(timer2)
    }
  }, [])

  return isDown ? (
    <styled.div className="h ba k bb"
      style={{
        '@media only screen and (max-width: 744px)': { border: 'none' },
      }}
    >
      <styled.div className="a i bc bd be"
        style={{
          color: colors.textPrimary,
          '@media only screen and (max-width: 744px)': {
            padding: '16px',
          },
        }}
      >
        <h3 className="bf">Unable to Connect</h3>
        <p className="bf">
          It looks like your connection to our service is currently being
          interrupted. This can happen if your network or firewall settings are
          blocking the connection, or if your internet access is unstable.
        </p>
        <p>
          Please check your network settings, firewall, or internet connection,
          and then try again. If the issue persists, rest assured we're
          monitoring closely to ensure smooth service for all our users.
        </p>
      </styled.div>
      <styled.div className="be bg"
        style={{
          '@media only screen and (max-width: 744px)': {
            padding: '16px',
            border: 'none',
          },
        }}
      >
        <Button
          id="infra-down-reload-page"
          on={{
            click: () => location.reload(),
          }}
          style={{ color: colors.textPrimary }}
        >
          Reload page
        </Button>
      </styled.div>
    </styled.div>
  ) : isSlow ? (
    <Spinner />
  ) : null
}

export const InfraDownPage = ({ loading }) => {
  if (!loading) {
    return null
  }

  return (
    <div className="bh bi a d c b bj"
    >
      <Loading />
    </div>
  )
}
